export const appName = "BITO";
